import { classed } from "@/lib/classed";

/**
 * VStack — vertical flex column with consistent gap.
 * Use for stacking content blocks, form sections, card internals.
 * Supports `as` prop: `<VStack as="section">` renders a `<section>`.
 */
export const VStack = classed("div", {
  base: "flex flex-col",
  variants: {
    gap: {
      none: "",
      xs: "gap-1",
      sm: "gap-2",
      md: "gap-3",
      lg: "gap-4",
      xl: "gap-6",
    },
    align: {
      start: "items-start",
      center: "items-center",
      end: "items-end",
    },
    justify: {
      start: "justify-start",
      center: "justify-center",
      end: "justify-end",
      between: "justify-between",
    },
    padding: {
      none: "",
      xs: "p-2",
      sm: "p-3",
      md: "p-4",
      lg: "p-6",
      xl: "p-8",
    },
    fill: {
      true: "flex-1",
    },
    shrink: {
      true: "flex-shrink-0",
    },
    truncate: {
      true: "min-w-0",
    },
    inline: {
      true: "inline-flex",
    },
  },
  defaultVariants: {
    gap: "md",
  },
});
